import React, { useState, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Select from "react-select";

/* ===================== TIME SLOTS ===================== */
const timeSlotMap = {
  "09:00-10:00": "09:00 AM – 10:00 AM",
  "10:00-11:00": "10:00 AM – 11:00 AM",
  "11:00-12:00": "11:00 AM – 12:00 PM",
  "12:00-13:00": "12:00 PM – 01:00 PM",
  "13:00-14:00": "01:00 PM – 02:00 PM",
  "14:00-15:00": "02:00 PM – 03:00 PM",
  "15:00-16:00": "03:00 PM – 04:00 PM",
  "16:00-17:00": "04:00 PM – 05:00 PM",
};

const timeSlotOptions = Object.entries(timeSlotMap).map(
  ([value, label]) => ({ value, label })
);

/* ===================== THERAPISTS ===================== */
const therapistOptions = [
  { value: "dr_anita_sharma", label: "Dr. Anita Sharma" },
  { value: "dr_rahul_verma", label: "Dr. Rahul Verma" },
  { value: "dr_priya_mehta", label: "Dr. Priya Mehta" },
  { value: "dr_suresh_patel", label: "Dr. Suresh Patel" },
];

/* ===================== SELECT STYLES ===================== */
const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: "50px",
    fontSize: "14px",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 8px",
  }),
  input: (base) => ({
    ...base,
    margin: "0px",
    fontSize: "14px",
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: "14px",
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: "14px",
  }),
};

/* ===================== INITIAL STATE ===================== */
const getInitialFormData = (event) => ({
  date: event?.startStr ? event.startStr.split("T")[0] : "",
  therapist: "",
  timeSlot: null,
});

/* ===================== COMPONENT ===================== */
const Reschedule = ({ isOpen, onClose, event, onSave }) => {
  const [formData, setFormData] = useState(getInitialFormData(event));
  const [saving, setSaving] = useState(false);

  /* Sync form when event changes */
  useEffect(() => {
    setFormData(getInitialFormData(event));
  }, [event]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleReset = () => {
    setFormData(getInitialFormData(event));
  };

  const handleSubmit = async () => {
    if (!formData.date || !formData.therapist || !formData.timeSlot) {
      alert("Please fill all fields");
      return;
    }

    setSaving(true);
    try {
      await onSave({
        eventId: event.id,
        date: formData.date,
        therapist: formData.therapist,
        timeSlot: formData.timeSlot.value,
      });
      onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Reschedule Treatment</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          {/* ================= DATE ================= */}
          <Form.Group className="mb-3 position-relative">
            <Form.Label>Date</Form.Label>
            <Form.Control
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              min={new Date().toISOString().split("T")[0]}
              style={{ paddingLeft: "40px" }}
            />
            <i
              className="fa fa-calendar"
              style={{
                position: "absolute",
                left: "12px",
                top: "50px",
                fontSize: "18px",
                color: "#555",
                pointerEvents: "none",
              }}
            />
          </Form.Group>

          {/* ================= TIME SLOT ================= */}
          <Form.Group className="mb-3">
            <Form.Label>Time Slot</Form.Label>
            <Select
              options={timeSlotOptions}
              styles={customStyles}
              value={formData.timeSlot}
              onChange={(selected) =>
                setFormData((prev) => ({ ...prev, timeSlot: selected }))
              }
              placeholder="Select Time Slot"
            />
          </Form.Group>

          {/* ================= THERAPIST ================= */}
          <Form.Group className="mb-3">
            <Form.Label>Therapist</Form.Label>
            <Select
              options={therapistOptions}
              styles={customStyles}
              placeholder="Select Therapist"
              value={therapistOptions.find(
                (opt) => opt.value === formData.therapist
              )}
              onChange={(selected) =>
                setFormData((prev) => ({
                  ...prev,
                  therapist: selected.value,
                }))
              }
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
      <Button variant="danger" onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        {/* <Button variant="info" onClick={handleReset} disabled={saving}>
          Reset
        </Button> */}
      
        <Button variant="primary" onClick={handleSubmit} disabled={saving}>
          {saving ? "Rescheduling..." : "Reschedule"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Reschedule;
